import { application } from "./application"
import TweakwiseCartPickerController from "./tweakwise_cart_picker_controller"
import TweakwiseProductListerController from "./tweakwise_product_lister_controller"
import PricingTableController from "./pricing_table_controller"
import AddressAutocompleteController from "./address_autocomplete_controller"

application.register("tweakwise-cart-picker", TweakwiseCartPickerController)
application.register("tweakwise-product-lister", TweakwiseProductListerController)
application.register("pricing-table", PricingTableController)
application.register("address-autocomplete", AddressAutocompleteController)
